/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { useEffect } from 'react';
// next
import { Container, Divider, Grid } from '@mui/material';
import { useDispatch } from '../../../redux/store';

// @mui
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import Page from '../../../components/Page';
import useLocales from '../../../hooks/useLocales';
import useSettings from '../../../hooks/useSettings';
import Layout from '../../../layouts';
import { setCommentSearch } from '../../../redux/slices/blog/blog.comment';
import { setPost } from '../../../redux/slices/blog/blog.post';
import { PATH_PAGE, PATH_RESOURCE } from '../../../routes/paths';
import { PostDescription } from '../../../sections/blog/post/PostDescription';
import { getPostBySlug } from '../../../service/blog/blog.post.service';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(10),
  paddingTop: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(12),
  },
}));

PostPage.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

export default function PostPage({ currentItem }) {
  const dispatch = useDispatch();
  const { themeStretch } = useSettings();
  const { translate } = useLocales();

  const { search: searchComment } = useSelector((state) => state.blogComment);

  useEffect(() => {
    dispatch(setPost(currentItem));
    dispatch(setCommentSearch({ ...searchComment, value: '', page: 0, filterBys: { itemId: currentItem.id, type: "POST" } }));
  }, [currentItem]);

  return (
    <Page title={currentItem.title} description={currentItem.metaDescription} imagePath={currentItem.featureImage}>
      <RootStyle>
        <Container maxWidth={themeStretch ? 'xl' : 'lg'} >
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <HeaderBreadcrumbs
                links={[
                  { name: translate("menu.hackerthon"), href: PATH_PAGE.home },
                  { name: translate("menu.blog"), href: PATH_RESOURCE.blogs },
                  { name: (currentItem.title) },
                ]}
              />
              <Divider sx={{ mb: 2 }} />
              <PostDescription />
              {/* <BlogPostRecent /> */}
            </Grid>
          </Grid>
        </Container>
      </RootStyle>
    </Page>
  );
}

export async function getStaticPaths() {
  const paths = [{ params: { slug: '/test' } }];
  return { paths, fallback: 'blocking' };
}

export async function getStaticProps({ params }) {
  const { slug } = params;

  const { code, data: currentItem } = await getPostBySlug(slug);

  if (code !== '200') {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      currentItem,
    },
  };
}
